import clsx from 'clsx';
import { useFitText } from '@flyyer/use-fit-text';
import '../../../../font.css';
import { addPontis } from '../../../../store/utils';
import { FitPriceProps } from '.';
import { useEffect, useState } from 'react';

export default function FitPricePrimary({
  width = 0,
  height = 0,
  matrix = [0, 0, 0, 0, 0, 0],
  text = '',
  top = 0,
  left = 0,
  right,
  color = [0, 0, 0],
  textAlign,
  display = 'flex',
  margin = 'auto',
  fontFamily = '"Primary"',
  fontWeight = 'normal',
  params,
}: FitPriceProps) {
  const [refresh, setRefresh] = useState(false);
  const isRight = right !== undefined ? true : false;
  // UI-dependent variables (title and description) are added to the hook's dependency array.
  const { ref, fontSize, isCalculating } = useFitText(
    {
      /** Depends on body's fontSize (usually 16px) */
      maxFontSize: 2000, // 1000%
      /** Lower values are more strict but causes more renders, defaults to `5` */
      resolution: 10,
    },
    [width, height, text, refresh],
  );

  const real = addPontis(Math.floor(+text / 100).toString());
  const cent = (+text % 100).toString().padStart(2, '0');
  const className = clsx({ 'flyyer-wait': isCalculating }); // use class flyyer-wait to prevent eager renders of flyyer templates.
  const unit = params?.[0];
  const unitFontweight = params?.[1];

  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);
      setRefresh(!refresh);
    }, 1000);
  }, []);

  return (
    <div
      style={{
        transition: 'transform 500ms, color 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
        color: `rgb(${color[0]},${color[1]},${color[2]})`,
      }}
    >
      <div
        ref={ref}
        style={{
          position: 'absolute',
          display,
          transition:
            'height 500ms, width 500ms, top 500ms, left 500ms, right 500ms',
          top,
          ...(() => (isRight ? { right } : { left }))(),
          fontSize,
          fontFamily,
          fontWeight,
          letterSpacing: '2px',
          height,
          width,
          whiteSpace: 'pre',
          textAlign,
          // background: `rgba(255, 163, 18, 0.53)`,
        }}
        className={className}
      >
        <div
          style={{
            margin,
          }}
        >
          <span
            style={{
              fontSize,
            }}
          >
            {real}
          </span>
          <span
            style={{
              display: 'inline-flex',
              fontSize: `calc(${fontSize} * 0.6)`,
              transform: 'translateY(-35%)',
            }}
          >
            {`,${cent}`}
            {unit ? (
              <span
                style={{
                  position: 'absolute',
                  fontSize: `22%`,
                  bottom: '-7%',
                  right: '8%',
                  color: `rgb(${color[0]},${color[1]},${color[2]})`,
                  width: '68%',
                  fontWeight: unitFontweight,
                  textAlign: 'center',
                }}
              >
                {unit}
              </span>
            ) : null}
          </span>
        </div>
      </div>
    </div>
  );
}
